import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
	body: {
		height: "100%",
		width: "100%"
	},
	listContainer: {
		scrollbarWidth: "thin",
		scrollbarColor: "var(--color-purple-400) #f1f1f1",

		"&::-webkit-scrollbar-thumb": {
			backgroundColor: "var(--color-purple-400)"
		},
		"&::-webkit-scrollbar-thumb:hover": {
			backgroundColor: "var(--color-purple-500)"
		}
	},
	emptyListMessage: {
		display: "flex",
		justifyContent: "center",
		color: "var(--color-grey-700, #5F6066)",
		paddingTop: "120px"
	}
});
